var layoutSection = {
    content: 'layoutColumn{2,3}',
    isolating: true,
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true,
        },
        {
            tag: 'div[data-layout-section]',
        },
    ],
    toDOM: function () {
        var attrs = { 'data-layout-section': 'true' };
        return ['div', attrs, 0];
    },
};

export { layoutSection };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/layout-section.js